<template>
  <div v-if="!maintenance" class="home">
    <hero-section />
  </div>
  <div v-else>
    <q-page class="page-bg q-pa-md column justify-center">
      <img
        class="self-center q-mt-xl"
        src="../assets/Maintenance.svg"
        alt="Under Maintenance"
      />
      <div class="self-center text-h5">
        {{ t("maintenance.text") }}
      </div>
    </q-page>
  </div>
</template>

<script>
import HeroSection from "@/components/HeroSection.vue";
import { store } from "../store/store";
import { useI18n } from "vue-i18n";

export default {
  name: "Home",
  components: {
    HeroSection,
  },
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });

    return {
      t,
    };
  },
  data() {
    return {
      maintenance: store.state.maintenance,
    };
  },
};
</script>

<style scoped>
.page-bg{
  background:linear-gradient(-45deg,rgb(1, 90, 6),rgb(5, 145, 5),rgb(5, 145, 5),rgb(0, 110, 255)) ;
}
</style>
